import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=743a5a1f&"
import script from "./UiButton.vue?vue&type=script&lang=js&"
export * from "./UiButton.vue?vue&type=script&lang=js&"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=743a5a1f&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports